import React from "react";
import { Checkbox, Col, Row } from "@folio/stripes/components";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import { AccordionSection } from "../../../AccordionSection";
import css from "../reports.module.css";
export var GdprSection = function (_a) {
    var control = _a.control, open = _a.open, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(AccordionSection, { id: "progress-report-gdpr", labelId: "ui-br-agency.outputs.progress-report.section.gdpr", open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "gdprConsent", render: function (_a) {
                        var _b;
                        var _c = _a.field, value = _c.value, onChange = _c.onChange, fieldState = _a.fieldState;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Checkbox, { label: formatMessage({
                                    id: "ui-br-agency.outputs.progress-report.field.gdprConsent",
                                }), checked: value, onChange: function (e) {
                                    return onChange(e.target.checked);
                                } }),
                            ((_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message) && (React.createElement("div", { className: css.checkboxError }, fieldState.error.message))));
                    } })))));
};
